import { FeatureFlagKey } from "encamp-shared/src/featureFlags";
import { useMatch } from "react-router-dom";

import { useFeatureFlags } from "./useFeatureFlags";

/**
 * This hook is only enabled for the new landing page / new navigation experience.
 * It returns true if the current route is a home route.
 * A home route is any route that is a child of the root route.
 * This includes:
 * - /
 * - /staff
 * - /o/:tenantId
 */
export function useHomeRoute() {
  const { featureFlags } = useFeatureFlags();

  const rootMatch = useMatch("/");
  const staffMatch = useMatch("/staff");
  const tenantMatch = useMatch("/o/:tenantId");

  if (!featureFlags?.[FeatureFlagKey.LeftNavV2]) {
    return false;
  }

  return Boolean(rootMatch) || Boolean(staffMatch) || Boolean(tenantMatch);
}
